import { useEffect, useState } from "react";
import { useRef } from "react";
import Webcam from "react-webcam";
import { Accordion, Button, Form, Modal } from "react-bootstrap";

import "./uploadDocument.css";
import "../../css/slick-theme.css";
import "../../css/slick.css";
import "../../css/style.css";
import "../../css/responsive.css";

import { useDispatch, useSelector } from "react-redux";
import {
  closeCameraModel,
  closeConfirmDataModel,
  openCameraModel,
  openConfirmDataModel,
  setTickModelTrue,
  openServiceListDisplayModel,
  openDocumentsDisplayModel,
} from "../../store/slices/modalSlice";
import ConfirmDataModel from "../../components/confirmDataModel/ConfirmDataModel";
import { base64ToFile } from "../../lib/api";
import CameraModel from "../../components/cameraModel/CameraModel";

import axiosInstance from "../../api/axiosInstance";
import {
  setFromDeleteService,
  setFromDeleteDoc,
  setGlobalLoading,
} from "../../store/slices/IdSlice";

import io from "socket.io-client";
import axios from "axios";
import TickModel from "../../components/confirmDataModel/TickModel";
import ServiceListDisplayModel from "../../components/serviceListDisplayModel/serviceListDisplayModel";
import DocumentsDisplayModel from "../../components/documentsDisplayModel/documentsDisplayModel";
import HandlePackageAndServiceModel from "../../components/handleModel/HandlePackageAndServiceModel";
import Certification from "../../components/Certification/Certification";
import { useNavigate } from "react-router-dom";
import {
  ApplicantStatus,
  Field,
  FieldType,
  SessionData,
  ApplicantFieldData,
  MultiFields,
} from "../../types/uploadDocument";
import { useUploadModal } from "../../context/UploadModalContext";

const baseUrl = import.meta.env.VITE_API_URL;
const AppUrl = import.meta.env.VITE_APPLICATION_URL;

const UploadDocumentLatest = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { showUploadMobileModal, closeUploadMobileModal } = useUploadModal();
  const { showGuidelineMobileModal, closeGuidelineMobileModal } =
    useUploadModal();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [UUID, setUUID] = useState<string>("");
  const [responseData, setResponseData] = useState<any[]>([]);
  const [status, setStatus] = useState<ApplicantStatus[]>([]);
  const [fields, setFields] = useState<Field[]>([]);

  const [selectedField, setSeletedField] = useState<FieldType | null>(null);
  const [uploadFieldData, setUploadFieldData] = useState<Field | null>(null);

  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewURL, setPreviewURL] = useState<string | null>(null);
  const [fieldPreviewURL, setFieldPreviewURL] = useState<string>("");

  const [isCameraOn, setIsCameraOn] = useState(false);
  const [capturedImage, setCapturedImage] = useState<string | null>(null);
  const webcamRef = useRef<Webcam>(null);

  const openModel = useSelector((state: any) => state.modal.cameraModel);
  const confirmDataModel = useSelector((state: any) => state.modal.confirmData);
  const tickModel = useSelector((state: any) => state.modal.tickModel);

  const [session, setSession] = useState<SessionData | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [activeFieldId, setActiveFieldId] = useState<number | null>(null);
  const [activeMultiFieldId, setActiveMultiFieldId] = useState<number | null>(
    null
  );
  const [activeAccordion, setActiveAccordion] = useState<string | null>(null);
  const [areAllFieldsUploaded, setAreAllFieldsUploaded] =
    useState<boolean>(false);

  const [applicantFieldsData, setApplicantFieldsData] =
    useState<ApplicantFieldData[]>();

  const [socketInstance, setSocketInstance] = useState<any>(null);
  
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const uuidd = localStorage.getItem("uuid");
    if (uuidd) {
      setUUID(uuidd);
      fetchApplicantData(uuidd);
    }
  }, []);

  useEffect(() => {
    return () => {
      if (fieldPreviewURL.startsWith("blob:")) {
        URL.revokeObjectURL(fieldPreviewURL);
      }
    };
  }, [fieldPreviewURL]);

  // useEffect(() => {
  //   const handler = async (data: any) => {
  //     const mime = data.mimetype;
  //     const base64 = data.buffer;
  //     const file = base64ToFile(
  //       `data:${mime};base64,${base64}`,
  //       data.filename || "upload.jpg"
  //     );

  //     setSelectedFile(file);
  //     setPreviewURL(
  //       file.type === "application/pdf"
  //         ? "https://cdn-icons-png.flaticon.com/512/337/337946.png"
  //         : `data:${mime};base64,${base64}`
  //     );

  //     dispatch(closeCameraModel());
  //     dispatch(setTickModelTrue());
  //   };

  //   socket.on("image-uploaded", handler);

  //   return () => {
  //     socket.off("image-uploaded", handler);
  //   };
  // }, []);

  const fetchApplicantData = async (uuidd?: string) => {
    dispatch(setGlobalLoading(true));
    try {
      const response = await axiosInstance.get(
        `api/applicantUpload/getUploadDocuments?UUID=${uuidd}`
      );

      if (response.data.data && response.data.data.length) {
        setResponseData(response.data.data);
      } else {
        return navigate("/");
      }
    } catch (error: any) {
      setError(true);
      if (error.response && error.response.status === 404) {
        navigate("/");
      }
      console.error("Error fetching data:", error);
    } finally {
      dispatch(setGlobalLoading(false));
    }
  };

  const handleFileChange = (event: any) => {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "application/pdf",
      "image/jpg",
    ];
    if (!allowedTypes.includes(file.type)) {
      setError(true);
      setSelectedFile(file);
      return;
    }
    setSelectedFile(file);
    setError(false);

    if (file.type === "application/pdf") {
      setPreviewURL("https://cdn-icons-png.flaticon.com/512/337/337946.png");
    } else {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        if (typeof fileReader.result === "string") {
          setPreviewURL(fileReader.result);
        } else {
          setPreviewURL(null);
        }
      };
      fileReader.readAsDataURL(file);
    }
  };

  dispatch(setFromDeleteService(true));
  const capture = () => {
    const imageSrc = webcamRef.current?.getScreenshot();
    setCapturedImage(imageSrc || null);
    setIsCameraOn(false);
  };

  const handleTryAgainLive = () => {
    setCapturedImage(null);
    setIsCameraOn(true);
  };

  const handleApplicantDataChange = (index: number, value: string) => {
    if (!applicantFieldsData) return;
    const updatedFields = [...applicantFieldsData];
    updatedFields[index].value = value;
    setApplicantFieldsData(updatedFields);
  };

  const serviceListDisplayModel = useSelector(
    (state: { modal: { serviceListDisplayModel: boolean } }) =>
      state.modal.serviceListDisplayModel
  );

  const documentsDisplayModel = useSelector(
    (state: { modal: { documentsDisplayModel: boolean } }) =>
      state.modal.documentsDisplayModel
  );

  const generateSession = async () => {
    const { data } = await axios.get<SessionData>(
      `${baseUrl}/generate-session`
    );
    setSession(data);
    dispatch(openCameraModel());
    if (socketInstance) {
      socketInstance.disconnect();
    }
    // Create new socket
    const newSocket = io(`${baseUrl}`);
    setSocketInstance(newSocket);

    newSocket.emit("register", { sessionId: data.sessionId, client: "desktop" });

    // Listen for image-uploaded event
    newSocket.on("image-uploaded", (data: any) => {
      const file = base64ToFile(
        `data:${data.mimetype};base64,${data.buffer}`,
        data.filename || "upload.jpg"
      );
      setSelectedFile(file);
      setPreviewURL(
        file.type === "application/pdf"
          ? "https://cdn-icons-png.flaticon.com/512/337/337946.png"
          : `data:${data.mimetype};base64,${data.buffer}`
      );
      dispatch(closeCameraModel());
      dispatch(setTickModelTrue());
    });
  };

  useEffect(() => {
    return () => {
      if (socketInstance) {
        socketInstance.disconnect();
        setSocketInstance(null);
      }
    };
  }, [socketInstance]);


  const handleConfirmWeb = () => {
    setPreviewURL(capturedImage || null);
    const file = base64ToFile(capturedImage, "webcam_image.jpg");
    setSelectedFile(file);
    setCapturedImage(null);
    setIsCameraOn(false);
  };

  const handleConfirm = async () => {
    if (!selectedFile) {
      setError(true);
      setSelectedFile(null);
      setPreviewURL(null);
      return;
    }
    setLoading(true);
    const returnObject = await uploadFile(selectedFile);

    if (returnObject === "File uploaded and saved successfully") {
      const uuiddd = localStorage.getItem("uuid");
      if (uuiddd) {
        fetchApplicantData(uuiddd);
      }

      setTimeout(() => {
        dispatch(closeConfirmDataModel());
        setLoading(false);
      }, 300);
    } else {
      setLoading(false);
      setError(true);
    }
  };

  const uploadFile = async (file: File) => {
    dispatch(openConfirmDataModel());
    setLoading(true);
    const formData = new FormData();
    const activeApplicant = status.find((item) => item.status === "active");

    const applicantData = responseData.find(
      (r) =>
        r.applicant_Name === activeApplicant?.applicant_Name &&
        r.Applicant_PassPort === activeApplicant?.Applicant_PassPort
    );

    if (!applicantData) {
      console.error("Full applicant data not found.");
      return;
    }

    if (activeApplicant) {
      formData.append("applicant_Name", applicantData.applicant_Name);
      formData.append("applicantId", applicantData.applicantid);
      formData.append(
        "FormFieldId",
        selectedField?.RecordId != null ? String(selectedField.RecordId) : "0"
      );
      formData.append("labelName", selectedField?.Label ?? "");
      formData.append("isScraping", String(selectedField?.isScraping ?? ""));
    }
    formData.append("UUID", String(UUID ?? ""));
    formData.append("file", file);

    try {
      const [response] = await Promise.all([
        axiosInstance.post(`/api/applicantUpload/ApplicantData`, formData),
        new Promise((resolve) => setTimeout(resolve, 8000)), // 5 seconds timeout
      ]);
      return response.data?.message ?? null;
    } catch (error) {
      setLoading(false);
      console.error("Error uploading file:", error);
      return null;
    }
  };

  const saveApplicantInfo = async () => {
    try {
      const activeApplicant = status.find((s) => s.status === "active");

      if (!activeApplicant || !applicantFieldsData) {
        console.error("No active applicant or form data found to save.");
        return;
      }

      const applicantData = responseData.find(
        (r) =>
          r.applicant_Name === activeApplicant.applicant_Name &&
          r.Applicant_PassPort === activeApplicant.Applicant_PassPort
      );

      if (!applicantData) {
        console.error("Full applicant data not found.");
        return;
      }

      const infoJson = applicantFieldsData.reduce((acc, field) => {
        acc[field.labelName] = field.value;
        return acc;
      }, {} as Record<string, string>);

      const payload = {
        ApplicantID: applicantData.applicantid,
        ApplicantInfoJson: JSON.stringify(infoJson),
      };

      await axiosInstance.post(
        "/api/applicantUpload/saveApplicantInfoJson",
        payload
      );
      const uuiddd = localStorage.getItem("uuid");
      if (uuiddd) {
        fetchApplicantData(uuiddd);
      }
    } catch (error) {
      console.error("Error saving applicant info:", error);
    }
  };

  const handleContinue = () => {
    if (areAllFieldsUploaded) {
      saveApplicantInfo();
    }
    const allUploaded = fields.every((field) => field.uploaded === true);

    setStatus((prevStatus) => {
      let foundFirst = false;
      let shouldSetNextActive = false;

      const updatedStatus = prevStatus.map((st) => {
        if (st.status === "active" && allUploaded) {
          return { ...st, checkAllData: true };
        }
        return st;
      });

      const checkAllDataTrue = updatedStatus.every(
        (st) => st.checkAllData === true
      );

      if (checkAllDataTrue) {
        setAreAllFieldsUploaded(false);
        navigate("/payment");
        return updatedStatus;
      }

      const nextStatus = updatedStatus.map((item) => {
        if (shouldSetNextActive) {
          shouldSetNextActive = false;
          return { ...item, status: "active" };
        }

        if (item.status === "active" && !foundFirst) {
          foundFirst = true;
          shouldSetNextActive = true;
          return { ...item, status: "" };
        }

        return item;
      });

      const activeIndex = updatedStatus.findIndex(
        (st) => st.status === "active"
      );

      if (activeIndex !== -1 && activeIndex < updatedStatus.length - 1) {
        const nextApplicant = updatedStatus[activeIndex + 1].applicant_Name;
        getFilesDataToUpload(UUID, nextApplicant);
      }

      return nextStatus;
    });
  };

  const getFilesDataToUpload = async (UUID: string, applicant_Name: string) => {
    const token = sessionStorage.getItem("tk");
    if (token) {
      try {
        const response = await axiosInstance.get(
          `/api/applicantUpload/getFilesDataToUpload?UUID=${UUID}&applicant_Name=${applicant_Name}`
        );

        if (response.data) {
          if (response.data) {
            const fieldss = await Promise.all(
              response.data.Fields.map(async (field: any) => {
                let previewURL: string | undefined = "";

                if (field.uploaded === true && field.Label) {
                  previewURL = await downloadFileNew(
                    field.ApplicantName,
                    field.stored_name
                  );
                }

                return {
                  ...field,
                  preview: field.original_name?.toLowerCase().includes(".pdf")
                    ? "https://cdn-icons-png.flaticon.com/512/337/337946.png"
                    : previewURL,
                };
              })
            );
            setFields(fieldss);
          }

          const firstUnuploadedField = response.data.Fields.find(
            (field: any) => field.uploaded !== true
          );

          if (firstUnuploadedField) {
            setSeletedField(firstUnuploadedField);
            if (firstUnuploadedField?.multiOptions.length) {
            }
          }
        }
      } catch (error) {
        console.error("Error fetching file data:", error);
      }
    }
  };

  const getApplicantFieldsData = async (
    applicant_Name: string,
    Applicant_PassPort: string
  ) => {
    const uuid = localStorage.getItem("uuid");

    try {
      const response = await axiosInstance.get(
        `/api/applicantUpload/getApplicantFieldsData`,
        {
          params: {
            applicant_Name,
            Applicant_PassPort,
            UUID: uuid,
          },
        }
      );


      if (response.status === 200) {
        const results = response.data;
        if (results && results.length > 0) {
          setApplicantFieldsData(results);
        }
      } else {
        console.warn("Unexpected response status:", response.status);
      }
    } catch (error: any) {
      console.error(
        "Error fetching applicant fields data:",
        error.response?.data || error.message
      );
    }
  };

  const downloadFileNew = async (
    ApplicantName: string,
    stored_name: string
  ) => {
    try {
      const response = await axiosInstance.get(
        `/api/applicantUpload/download/${ApplicantName}/${stored_name}`,
        {
          responseType: "blob",
        }
      );

      if (response) {
        const fileBlob = new Blob([response.data], {
          type: response.data.type,
        });
        const file = new File([fileBlob], stored_name, {
          type: response.data.type,
        });

        const preViewData = URL.createObjectURL(file);
        setFieldPreviewURL(preViewData);
        return preViewData;
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const getClassForStatus = (
    item: any,
    index: number,
    activeAccordionKey: string | null
  ) => {
    const allUploaded = item.FormFields.every((field: any) => field.uploaded);
    const someUploaded = item.FormFields.some((field: any) => field.uploaded);
    const isActive = activeAccordionKey === `active-${index}`;

    if (allUploaded) return "done";
    if (isActive || (someUploaded && activeAccordionKey === null))
      return "active";
    return "upcoming";
  };

  const getClassForField = (field: Field): string => {
    const isCurrentField = field.RecordId === activeFieldId;

    if (field.multiOptions?.length) {
      const allMultiUploaded = field.multiOptions.every((m) => m.uploaded);
      const someMultiUploaded = field.multiOptions.some((m) => m.uploaded);

      if (isCurrentField) return "active";
      if (allMultiUploaded) return "done";
      if (someMultiUploaded) return "active";
      return "upcoming";
    }
    if (isCurrentField) return "active";
    if (field.uploaded) return "done";
    return "upcoming";
  };

  const getMultiClass = (field: MultiFields) => {
    if (field.RecordId === activeMultiFieldId) return "current";
    if (field.uploaded) return "done";
    return "upcoming";
  };

  const isUploadedField = (field: Field) =>
    field.uploaded || field.multiOptions?.some((m) => m.uploaded);

  useEffect(() => {
    if (!responseData || responseData.length === 0) return;

    let selectedField: Field | null = null;
    let selectedMultiField: MultiFields | null = null;
    let foundAccordionIndex: number | null = null;
    let acticeFormFields: Field[] = [];

    for (let i = 0; i < responseData.length; i++) {
      const item = responseData[i];

      const field = item.FormFields.find(
        (f: Field) => !f.uploaded || f.multiOptions?.some((m) => !m.uploaded)
      );

      if (field) {
        foundAccordionIndex = i;
        selectedField = field;
        selectedMultiField =
          field.multiOptions?.find((m: MultiFields) => !m.uploaded) || null;
        acticeFormFields = [...item.FormFields]; // capture here to avoid async state bug
        break;
      }

      if (item.ApplicantInfoJson == null) {
        foundAccordionIndex = i;
        break;
      }
    }
    setFields(acticeFormFields);
    if (foundAccordionIndex !== null) {
      setActiveAccordion(`active-${foundAccordionIndex}`);
      setActiveFieldId(selectedField?.RecordId || null);
      setUploadFieldData(selectedField);
      setSeletedField(selectedMultiField || selectedField);
      setActiveMultiFieldId(selectedMultiField?.RecordId || null);
      if (acticeFormFields.length === 0) {
        setAreAllFieldsUploaded(true);
      }
    } else {
      setAreAllFieldsUploaded(false);
      navigate("/payment");
      return;
    }
    const applicantStatus = responseData.map((item) => ({
      applicant_Name: item.applicant_Name,
      status: item.status,
      checkAllData: item.ApplicantInfoJson != null ? true : false,
      type: "package",
      CartId: item.cartId,
      Applicant_PassPort: item.Applicant_PassPort,
    }));

    setStatus(applicantStatus);
    setSelectedFile(null);
    const fileUpload = acticeFormFields.every(
      (field) =>
        field.uploaded &&
        (Array.isArray(field.multiOptions)
          ? field.multiOptions.every((m) => m.uploaded)
          : true)
    );

    const activeApplicant = applicantStatus.find(
      (item) => item.status === "active"
    );
    if (activeApplicant && fileUpload) {
      getApplicantFieldsData(
        activeApplicant.applicant_Name,
        activeApplicant.Applicant_PassPort
      );
    }
  }, [responseData]);

  const fileSelecteChange = (field: Field) => {
    const multiOptions = field.multiOptions || [];
    const nextMulti =
      multiOptions.find((multi) => !multi.uploaded) || multiOptions[0] || null;
    setActiveFieldId(field?.RecordId || null);
    setUploadFieldData(field);
    setSeletedField(nextMulti || field);
    setError(false);

    setSelectedFile(null);
    setActiveMultiFieldId(nextMulti?.RecordId || null);
  };

  const handleAccordionToggle = (key: string, fields: Field[]) => {
    setActiveAccordion(activeAccordion === key ? null : key);
    let localFoundFieldId: number | null = null;
    let localMultiFoundFieldId: number | null = null;
    const firstUnuploadedField = fields.find((f: Field) => {
      return (
        f.multiOptions?.some((multi: MultiFields) => !multi.uploaded) ||
        !f.uploaded
      );
    });
    if (firstUnuploadedField) {
      localFoundFieldId = firstUnuploadedField.RecordId;
      if (firstUnuploadedField.multiOptions?.length) {
        const firstMultiUnuploadedField =
          firstUnuploadedField.multiOptions.find(
            (multi: MultiFields) => !multi.uploaded
          );
        if (firstMultiUnuploadedField) {
          localMultiFoundFieldId = firstMultiUnuploadedField?.RecordId;
        }
      }
    }
    setActiveFieldId(localFoundFieldId);
    setActiveMultiFieldId(localMultiFoundFieldId);
  };

  document.querySelectorAll(".form-floating-custom input").forEach((input) => {
    const inputEl = input as HTMLInputElement;
    if (inputEl.value) {
      inputEl.classList.add("filled");
    }
  });

  const [applicantLabel, setApplicantLabel] = useState<string | null>(null);

  return (
    <>
      <section className="upload-new-main">
        <div className="d-block d-md-flex align-items-start gap-3">
          {!isMobile && (
            <div className="upload-left">
              <div>
                <div className="font-13 text-black-50 ff-medium mb-3">
                  Upload document based on the below applicants
                </div>

                {/* DONE */}
                <div className="applicant-list">
                  <Accordion activeKey={activeAccordion}>
                    {responseData &&
                      responseData.map(
                        (item: any, index: number) =>
                          item?.ServiceIncludedDetail.length > 0 && (
                            <Accordion.Item
                              eventKey={`active-${index}`}
                              className={`applicant-box ${getClassForStatus(
                                item,
                                index,
                                activeAccordion
                              )}`}
                            >
                              <Accordion.Header>
                                <div
                                  className="d-flex justify-content-between align-items-center p-3 w-100"
                                  onClick={() =>
                                    handleAccordionToggle(
                                      `active-${index}`,
                                      item.FormFields
                                    )
                                  }
                                >
                                  <div className="d-flex align-items-center">
                                    {item.FormFields.every(
                                      (field: { uploaded: boolean }) =>
                                        field.uploaded
                                    ) && (
                                      <div className="tick-sv-icon">
                                        <svg
                                          width="18"
                                          height="19"
                                          viewBox="0 0 18 19"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                            fill="#458E4A"
                                          />
                                        </svg>
                                      </div>
                                    )}
                                    <span
                                      className={`flag-icon flag-icon-${
                                        item.Applicant_Country
                                          ? item.Applicant_Country.toLowerCase()
                                          : "ae"
                                      } me-1`}
                                    ></span>
                                    <p className="mb-0 text-black ff-medium font-14 upload-aaplicant-name">
                                      &nbsp;
                                      {item?.applicant_Name?.length > 22
                                        ? `${item.applicant_Name.slice(
                                            0,
                                            22
                                          )}...`
                                        : item.applicant_Name}{" "}
                                      - {item.Applicant_PassPort}
                                    </p>
                                    <p className="mb-0 ms-2 d-flex">
                                      <svg
                                        width="14"
                                        height="9"
                                        viewBox="0 0 14 9"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M1 1.5L7 7.5L13 1.5"
                                          stroke="#282828"
                                          strokeWidth="2"
                                          strokeLinecap="round"
                                          strokeLinejoin="round"
                                        />
                                      </svg>
                                    </p>
                                  </div>
                                  <div
                                    className="service-badge text-main ff-semibold font-13 text-center d-flex align-items-center "
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setApplicantLabel(
                                        item.applicant_Name +
                                          " - " +
                                          item.Applicant_PassPort
                                      );
                                      dispatch(
                                        openServiceListDisplayModel(
                                          item?.ServiceIncludedDetail
                                        )
                                      );
                                    }}
                                  >
                                    <div>
                                      {item.ServiceIncludedDetail &&
                                      item.ServiceIncludedDetail.length > 0
                                        ? item.ServiceIncludedDetail.length
                                        : 0}{" "}
                                      Services
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Header>
                              <Accordion.Body className="p-0">
                                <div className="upload-box p-0">
                                  <div className="upload-title d-flex align-items-center justify-content-between py-3 px-3 border-bottom mb-0 font-13 text-black ff-medium">
                                    <span>
                                      {" "}
                                      Total {item.FormFields.length} Documents
                                    </span>
                                    {item.FormFields.filter(
                                      (field: any) => field.uploaded
                                    ).length > 0 && (
                                      <div className="p-2 py-1 rounded-pill  bg-light-green text-dark-green ff-semibold font-11">
                                        {
                                          item.FormFields.filter(
                                            (field: any) => field.uploaded
                                          ).length
                                        }{" "}
                                        Uploaded{" "}
                                        <span className="ms-2">
                                          <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 14 14"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <path
                                              d="M10.5001 0.937925C11.5559 1.54752 12.4342 2.42229 13.048 3.47563C13.6619 4.52898 13.9899 5.72436 13.9998 6.94346C14.0096 8.16256 13.7009 9.36309 13.1042 10.4262C12.5075 11.4893 11.6434 12.3782 10.5976 13.0047C9.55179 13.6313 8.36046 13.9739 7.14156 13.9986C5.92265 14.0232 4.71844 13.7291 3.64813 13.1454C2.57782 12.5616 1.67853 11.7085 1.03928 10.6704C0.400028 9.63228 0.042987 8.44522 0.00350012 7.22672L0 6.99992L0.00350012 6.77312C0.0427028 5.56422 0.394488 4.3861 1.02456 3.35362C1.65463 2.32114 2.54149 1.46954 3.59867 0.881842C4.65585 0.294144 5.84727 -0.00959755 7.05679 0.000231172C8.26631 0.0100599 9.45264 0.333123 10.5001 0.937925ZM9.59502 5.10502C9.47448 4.9845 9.31411 4.9121 9.14399 4.9014C8.97387 4.89071 8.80569 4.94245 8.67101 5.04692L8.60521 5.10502L6.30008 7.40942L5.39497 6.50502L5.32917 6.44692C5.19447 6.34252 5.02632 6.29084 4.85624 6.30157C4.68616 6.3123 4.52584 6.38471 4.40534 6.50521C4.28484 6.62571 4.21243 6.78603 4.2017 6.95611C4.19097 7.12618 4.24265 7.29433 4.34705 7.42902L4.40515 7.49482L5.80517 8.89482L5.87097 8.95292C5.99373 9.04817 6.1447 9.09986 6.30008 9.09986C6.45546 9.09986 6.60642 9.04817 6.72918 8.95292L6.79498 8.89482L9.59502 6.09482L9.65312 6.02902C9.7576 5.89434 9.80934 5.72617 9.79864 5.55605C9.78795 5.38593 9.71554 5.22556 9.59502 5.10502Z"
                                              fill="#4E8059"
                                            />
                                          </svg>
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  <div className="p-2 pt-0 px-3 doc-listing-inside">
                                    {item.FormFields &&
                                    item.FormFields.length > 0 ? (
                                      item.FormFields.map(
                                        (field: Field, fieldIndex: number) => (
                                          <div
                                            className="doc-row"
                                            key={fieldIndex}
                                          >
                                            <div
                                              className={`doc-left d-flex align-items-center gap-2 ${getClassForField(
                                                field
                                              )}`}
                                            >
                                              {/* upcoming, done, completed */}
                                              <div
                                                className={`tick-sv-icon ${getClassForField(
                                                  field
                                                )}`}
                                              >
                                                <svg
                                                  width="18"
                                                  height="19"
                                                  viewBox="0 0 18 19"
                                                  fill="none"
                                                  xmlns="http://www.w3.org/2000/svg"
                                                >
                                                  <path
                                                    d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                                    fill="#458E4A"
                                                  />
                                                </svg>
                                              </div>
                                              <span
                                                onClick={() => {
                                                  fileSelecteChange(field);
                                                }}
                                                className="each-doc-list"
                                              >
                                                {field.Label}
                                              </span>
                                            </div>

                                            {isUploadedField(field) && (
                                              <div className="doc-actions d-flex align-items-center gap-2">
                                                <div
                                                  className="d-flex align-items-center justify-content-center upEye"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    dispatch(
                                                      setFromDeleteDoc(false)
                                                    );
                                                    dispatch(
                                                      openDocumentsDisplayModel(
                                                        field
                                                      )
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src="https://goodhand.b-cdn.net/Assets/Upload/up-eye.svg"
                                                    alt=""
                                                  />
                                                </div>
                                                <div
                                                  className="d-flex align-items-center justify-content-center upDlt"
                                                  onClick={(e) => {
                                                    e.stopPropagation();
                                                    dispatch(
                                                      setFromDeleteDoc(true)
                                                    );
                                                    dispatch(
                                                      openDocumentsDisplayModel(
                                                        field
                                                      )
                                                    );
                                                  }}
                                                >
                                                  <img
                                                    src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg"
                                                    alt=""
                                                  />
                                                </div>
                                              </div>
                                            )}
                                          </div>
                                        )
                                      )
                                    ) : (
                                      <div className="no-docs text-center py-3">
                                        No documents to upload
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Accordion.Body>
                            </Accordion.Item>
                          )
                      )}
                  </Accordion>
                </div>
              </div>
            </div>
          )}

          <div className="upload-middle flex-grow-1">
            <div className="uploading-flow mt-3 rounded-top">
              <div className="d-flex flex-column align-items-center col-md-11 mx-auto gap-3 text-dark-green up-badge-top pb-3 mb-5 ">
                <div className="secure-banner bg-2 font-14 font-sm-11 px-3 py-2 rounded-3 d-flex align-items-center justify-content-center gap-2 w-100 shadow-sm">
                  <svg
                    width="24"
                    height="25"
                    viewBox="0 0 24 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M11.9981 0L12.1399 0.0084107L12.2108 0.0180231L12.2841 0.0336431L12.4175 0.0744951C12.5096 0.108454 12.5972 0.153653 12.6782 0.209067L12.8032 0.307593L13.1096 0.569527C15.5334 2.58277 18.5968 3.66384 21.7474 3.61782L22.1583 3.6058C22.427 3.59354 22.692 3.67177 22.9109 3.82796C23.1298 3.98415 23.29 4.20928 23.3658 4.4673C23.9563 6.47576 24.1369 8.58241 23.8971 10.6621C23.6573 12.7417 23.0019 14.752 21.9698 16.5733C20.9378 18.3947 19.5501 19.99 17.8893 21.2645C16.2285 22.5389 14.3285 23.4666 12.3021 23.9922C12.1043 24.0435 11.8967 24.0435 11.699 23.9922C9.67247 23.4667 7.77231 22.5392 6.11138 21.2647C4.45046 19.9903 3.06267 18.395 2.03048 16.5737C0.998299 14.7523 0.342782 12.742 0.102889 10.6623C-0.137004 8.58256 0.043622 6.47584 0.634033 4.4673C0.709862 4.20928 0.870062 3.98415 1.08899 3.82796C1.30792 3.67177 1.57292 3.59354 1.84157 3.6058C5.13073 3.75615 8.35757 2.6734 10.8903 0.569527L11.2063 0.299182L11.3217 0.209067C11.4027 0.153653 11.4903 0.108454 11.5824 0.0744951L11.717 0.0336431C11.7641 0.0222689 11.8118 0.0138417 11.86 0.0084107L11.9981 0ZM16.4558 8.76278C16.3442 8.65107 16.2117 8.56244 16.0659 8.50198C15.92 8.44151 15.7636 8.41039 15.6057 8.41039C15.4478 8.41039 15.2915 8.44151 15.1456 8.50198C14.9998 8.56244 14.8672 8.65107 14.7557 8.76278L10.799 12.7182L9.24542 11.1658L9.13248 11.0661C8.89098 10.8794 8.58746 10.7916 8.28356 10.8205C7.97967 10.8495 7.69819 10.993 7.49629 11.222C7.29439 11.451 7.18722 11.7482 7.19653 12.0533C7.20585 12.3584 7.33096 12.6486 7.54645 12.8648L9.94952 15.2679L10.0625 15.3676C10.2936 15.5469 10.5823 15.6358 10.8743 15.6174C11.1663 15.599 11.4416 15.4748 11.6485 15.2679L16.4546 10.4617L16.5543 10.3488C16.7337 10.1176 16.8225 9.82896 16.8041 9.53695C16.7858 9.24495 16.6615 8.96968 16.4546 8.76278H16.4558Z"
                      fill="#316E57"
                    />
                  </svg>

                  <span className="ff-semibold">
                    protected with maximum security AES-256 encryption standard
                  </span>
                </div>
              </div>
              {!areAllFieldsUploaded && (
                <>
                  <div className="d-flex align-items-center justify-content-center mb-5 mx-3 mx-md-0 text-center tex-md-start">
                    <p className="py-1 bg-3 rounded-pill mb-2">
                      <span className="text-main font-14 ff-semibold px-3">
                        {selectedField?.TagLine}
                      </span>
                    </p>
                  </div>
                  {uploadFieldData && uploadFieldData?.multiOptions && uploadFieldData?.multiOptions?.length > 0 && (
                    <div className="d-flex flex-column align-items-center col-md-6 mx-auto gap-3 col-11 mb-5 ">
                      <div className="step-container">
                        <div className="step-line" />
                        {uploadFieldData?.multiOptions.map(
                          (multiOpt: MultiFields, multiIndex: number) => (
                            <div
                              className={`step-wrapper step ${getMultiClass(
                                multiOpt
                              )}`}
                              key={`multiOpt-${multiIndex}`}
                            >
                              <div className="step-circle">
                                <svg
                                  width="25"
                                  height="24"
                                  viewBox="0 0 25 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M18.5002 1.60787C20.3102 2.6529 21.8158 4.1525 22.8681 5.95823C23.9203 7.76396 24.4827 9.8132 24.4996 11.9031C24.5165 13.993 23.9873 16.051 22.9643 17.8735C21.9413 19.696 20.4601 21.2197 18.6673 22.2939C16.8745 23.368 14.8322 23.9553 12.7427 23.9975C10.6531 24.0398 8.58876 23.5357 6.75394 22.535C4.91913 21.5342 3.37748 20.0717 2.28162 18.2921C1.18576 16.5125 0.573692 14.4775 0.506 12.3887L0.5 11.9999L0.506 11.6111C0.573205 9.53866 1.17627 7.51902 2.25639 5.74906C3.33651 3.9791 4.85684 2.51921 6.66915 1.51173C8.48145 0.504246 10.5239 -0.0164529 12.5974 0.000396295C14.6708 0.0172455 16.7045 0.571068 18.5002 1.60787ZM16.9486 8.75147C16.742 8.54486 16.467 8.42074 16.1754 8.4024C15.8838 8.38407 15.5955 8.47277 15.3646 8.65187L15.2518 8.75147L11.3001 12.7019L9.74851 11.1515L9.63571 11.0519C9.40481 10.8729 9.11655 10.7843 8.82499 10.8027C8.53342 10.8211 8.25858 10.9452 8.05201 11.1518C7.84543 11.3584 7.72131 11.6332 7.70291 11.9248C7.68452 12.2163 7.77312 12.5046 7.95209 12.7355L8.05169 12.8483L10.4517 15.2483L10.5645 15.3479C10.775 15.5111 11.0338 15.5998 11.3001 15.5998C11.5665 15.5998 11.8253 15.5111 12.0357 15.3479L12.1485 15.2483L16.9486 10.4483L17.0482 10.3355C17.2273 10.1046 17.316 9.81628 17.2977 9.52465C17.2793 9.23302 17.1552 8.9581 16.9486 8.75147Z"
                                    fill="#282828"
                                  />
                                </svg>
                              </div>
                              <div
                                className={`step-label ${getMultiClass(
                                  multiOpt
                                )}`}
                              >
                                {multiOpt.PlaceHolder}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  )}
                  <div className="d-flex flex-column align-items-center col-md-6 mx-auto gap-3 col-11 ">
                    {/* <p className="text-black font-14 font-sm-12 ff-medium text-center mb-0 mb-md-2 ">
                      Please Upload {selectedField?.TagLine ?? selectedField?.Label}
                    </p> */}
                    {!error && !selectedFile && (
                      <div className="d-flex align-items-center justify-content-center gap-3  text-center mb-4 upload-bt-meain-wrap">
                        <label className="px-3 py-2 rounded-3 bg-primary  ff-medium d-flex align-items-center gap-2 cursor-pointer ">
                          <div>
                            <img
                              src="https://goodhand.b-cdn.net/Assets/Upload/upload-ico.svg"
                              alt=""
                            />
                          </div>
                          <p className="mb-0 text-white font-13">
                            Upload or drag document{" "}
                          </p>

                          <input
                            type={selectedField?.Type || "file"}
                            className="hidden-inputt"
                            onChange={handleFileChange}
                            accept={
                              selectedField?.FileTypes || ".jpg,.png,.pdf"
                            }
                          />
                        </label>

                        <div className="d-none d-md-block">
                          <div
                            onClick={generateSession}
                            className=" bg-dark px-3 py-2 rounded-3  ff-medium d-flex align-items-center gap-2 cursor-pointer"
                          >
                            <div>
                              <img
                                src="https://goodhand.b-cdn.net/Assets/Upload/gallery-icon.svg"
                                alt=""
                              />
                            </div>
                            <span className="d-block font-13 ff-semibold text-white">
                              Upload from Phone
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                    {error && selectedFile && (
                      <>
                        <div className="alret-main-up">
                          <div className="d-flex align-items-center gap-2 p-2 bg-light-red justify-content-center rounded-3 mb-4 px-3">
                            <div>
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M15 1.33989C16.5202 2.21758 17.7826 3.47997 18.6603 5.00017C19.538 6.52038 20 8.24483 20 10.0002C20 11.7556 19.5379 13.48 18.6602 15.0002C17.7825 16.5204 16.5201 17.7828 14.9999 18.6605C13.4797 19.5381 11.7552 20.0002 9.99984 20.0001C8.24446 20.0001 6.52002 19.538 4.99984 18.6603C3.47965 17.7826 2.21729 16.5202 1.33963 15C0.46198 13.4797 -4.45897e-05 11.7553 3.22765e-09 9.99989L0.00500012 9.67589C0.0610032 7.94888 0.563548 6.26585 1.46364 4.79089C2.36373 3.31592 3.63065 2.09934 5.14089 1.25977C6.65113 0.420205 8.35315 -0.0137108 10.081 0.000330246C11.8089 0.0143713 13.5036 0.47589 15 1.33989ZM10 12.9999C9.73478 12.9999 9.48043 13.1052 9.29289 13.2928C9.10536 13.4803 9 13.7347 9 13.9999V14.0099C9 14.2751 9.10536 14.5295 9.29289 14.717C9.48043 14.9045 9.73478 15.0099 10 15.0099C10.2652 15.0099 10.5196 14.9045 10.7071 14.717C10.8946 14.5295 11 14.2751 11 14.0099V13.9999C11 13.7347 10.8946 13.4803 10.7071 13.2928C10.5196 13.1052 10.2652 12.9999 10 12.9999ZM10 5.99989C9.73478 5.99989 9.48043 6.10525 9.29289 6.29279C9.10536 6.48032 9 6.73468 9 6.99989V10.9999C9 11.2651 9.10536 11.5195 9.29289 11.707C9.48043 11.8945 9.73478 11.9999 10 11.9999C10.2652 11.9999 10.5196 11.8945 10.7071 11.707C10.8946 11.5195 11 11.2651 11 10.9999V6.99989C11 6.73468 10.8946 6.48032 10.7071 6.29279C10.5196 6.10525 10.2652 5.99989 10 5.99989Z"
                                  fill="#F55353"
                                />
                              </svg>
                            </div>
                            <p className=" font-12 text-danger mb-0 ff-semibold">
                              {selectedField?.PlaceHolder} as shown below
                            </p>
                          </div>

                          <div className="preview-container-up w-100 mb-4">
                            {previewURL &&
                            selectedFile.type !== "application/pdf" ? (
                              <img
                                src={previewURL}
                                style={{ filter: "blur(3px)" }}
                                alt="Uploaded file"
                                className="preview-image-up img-fluid"
                              />
                            ) : (
                              <>
                                <img
                                  src={previewURL ?? ""}
                                  style={{ filter: "blur(3px)" }}
                                  alt="PDF Icon"
                                  className="pdf-icon"
                                />
                                <p className="mt-2 text-black ff-semibold font-12  selectedFilename-up">
                                  {selectedFile.name}
                                </p>
                              </>
                            )}
                          </div>

                          <div className="col-12">
                            <div className="d-flex  ">
                              <div className="px-3 py-2 rounded-3 bg-primary justify-content-center  ff-medium d-flex align-items-center gap-2 cursor-pointer upload-bt-meain-wrap">
                                <label className="d-flex align-items-center gap-2 cursor-pointer ">
                                  <div>
                                    <img
                                      src="https://goodhand.b-cdn.net/Assets/Upload/upload-ico.svg"
                                      alt=""
                                    />
                                  </div>
                                  <p className="mb-0 text-white font-13">
                                    {" "}
                                    upload it again
                                  </p>
                                  <input
                                    type={selectedField?.Type || "file"}
                                    className="hidden-inputt"
                                    onChange={handleFileChange}
                                    accept={
                                      selectedField?.FileTypes ||
                                      ".jpg,.png,.pdf"
                                    }
                                  />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {!error && selectedFile && (
                      <>
                        <div className="preview-container-up w-100">
                          {uploadFieldData && uploadFieldData?.multiOptions && uploadFieldData?.multiOptions?.length > 0 && (
                            <div className="d-flex align-items-center justify-content-center">
                              <p className="text-white font-14 px-3 py-1 bg-main rounded-pill">
                                {selectedField?.PlaceHolder}
                              </p>
                            </div>
                          )}
                          {previewURL &&
                          selectedFile.type !== "application/pdf" ? (
                            <img
                              src={previewURL}
                              alt="Uploaded file"
                              className="preview-image-up img-fluid"
                            />
                          ) : (
                            <div className="text-center d-flex justify-content-center align-items-center flex-column">
                              <img
                                src={previewURL ?? ""}
                                alt="PDF Icon"
                                className="pdf-icon"
                              />
                              <p className="mt-2 text-black ff-semibold font-12  selectedFilename-up">
                                {selectedFile.name}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="col-12">
                          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3 ">
                            <div className="bg-black px-3 py-2 rounded-3  ff-medium d-flex align-items-center gap-2 cursor-pointer upload-bt-meain-wrap">
                              <label className="d-flex align-items-center gap-2 cursor-pointer upload-bt-meain">
                                <div>
                                  <img
                                    src="https://goodhand.b-cdn.net/Assets/Upload/gallery-icon.svg"
                                    alt=""
                                  />
                                </div>
                                <p className="mb-0 text-white font-13">
                                  {" "}
                                  Re-upload Photo
                                </p>
                                <input
                                  type={selectedField?.Type || "file"}
                                  className="hidden-inputt"
                                  onChange={handleFileChange}
                                  accept={
                                    selectedField?.FileTypes || ".jpg,.png,.pdf"
                                  }
                                />
                              </label>
                            </div>

                            {loading && confirmDataModel && (
                              <ConfirmDataModel />
                            )}
                            <div
                              className="px-3 py-2 rounded-3 bg-primary  ff-medium d-flex align-items-center gap-2 cursor-pointer w-res-100 "
                              onClick={handleConfirm}
                            >
                              <div>
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/upload-ico.svg"
                                  alt=""
                                />
                              </div>
                              <p className="mb-0 text-white font-13">
                                {" "}
                                Confirm upload
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    <div className="">
                      <p className="mb-0 font-14 ff-medium">
                        (scan the QR code and select document from your phone)
                      </p>
                    </div>
                    <div className="d-flex align-items-center w-100 px-4">
                      <div className="flex-grow-1 border-top border-secondary border-opacity-25 "></div>
                      <span className="mx-3 flex-shrink-0 ff-semibold text-black-50">
                        OR
                      </span>
                      <div className="flex-grow-1 border-top border-secondary border-opacity-25 "></div>
                    </div>
                    <div className="live-scan d-flex flex-column align-items-center justify-content-center rounded-4   bg-opacity-75 mt-3 mb-5 mb-md-0 ">
                      {!isCameraOn && !capturedImage && (
                        <button
                          type="button"
                          className="position-relative w-auto overflow-hidden rounded-3 border-0 bg-white px-4 py-2 ff-medium text-dark d-flex align-items-center gap-3 "
                          onClick={() => setIsCameraOn(true)}
                        >
                          <img
                            src="https://goodhand.b-cdn.net/Assets/Upload/livescan.svg"
                            alt=""
                          />
                          Live Scan with Camera
                        </button>
                      )}

                      {isCameraOn && !capturedImage && (
                        <div className="d-flex justify-content-between flex-column align-items-center  w-100 h-100">
                          <Webcam
                            audio={false}
                            ref={webcamRef}
                            screenshotFormat="image/jpeg"
                            className="rounded-4 border w-100"
                          />
                          {/* take a pic */}
                          <div className="d-flex align-items-center justify-content-between gap-3 live-scan-actions  ">
                            <div className="bg-white rounded-pill">
                              <div
                                className=" w-100 ff-semibold camera-manage"
                                onClick={capture}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/camera-live.svg"
                                  alt=""
                                />
                              </div>

                              <div className="py-0 my-0 mx-2 d-flex">
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/Line%2024.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                className="w-100 ff-semibold camera-manage"
                                onClick={() => setIsCameraOn(false)}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/close-live.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {capturedImage && (
                        <div className="d-flex justify-content-between flex-column align-items-center  w-100 h-100">
                          <img
                            src={capturedImage}
                            alt="Captured"
                            className="rounded-4 border w-100 h-75"
                          />
                          <div className="d-flex align-items-center justify-content-between gap-3 live-scan-actions  ">
                            <div className="bg-white rounded-pill">
                              <div
                                className="white-bttn w-100 ff-semibold camera-manage"
                                onClick={handleConfirmWeb}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/done-live-scan.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                className=" w-100 ff-semibold camera-manage"
                                onClick={handleTryAgainLive}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/camera-live.svg"
                                  alt=""
                                />
                              </div>

                              <div className="py-0 my-0 mx-2 d-flex">
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/Line%2024.svg"
                                  alt=""
                                />
                              </div>
                              <div
                                className="w-100 ff-semibold camera-manage"
                                onClick={capture}
                              >
                                <img
                                  src="https://goodhand.b-cdn.net/Assets/Upload/close-live.svg"
                                  alt=""
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
              {areAllFieldsUploaded && (
                <div className="form-flow ">
                  <div className="upload-form-sec d-flex flex-column align-items-center col-md-6 mx-auto gap-3 p-3">
                    <p className="font-21 ff-semibold text-black mb-0 ">
                      Review your information
                    </p>
                    <div className="row up-form">
                      <div>
                        {applicantFieldsData &&
                          applicantFieldsData?.map((inputData, index) => (
                            <>
                              <div className="form-group mt-2">
                                <Form.Group className="mb-3 " key={index}>
                                  <div className="form-group">
                                    <Form.Control
                                      type={inputData?.type || "text"}
                                      id={`field_${index}`}
                                      name={`field_${index}`}
                                      value={inputData.value}
                                      placeholder={inputData.labelName}
                                      onChange={(e) =>
                                        handleApplicantDataChange(
                                          index,
                                          e.target.value
                                        )
                                      }
                                    />
                                    <Form.Label htmlFor={`field_${index}`}>
                                      {inputData.labelName}
                                    </Form.Label>
                                  </div>
                                </Form.Group>
                              </div>
                            </>
                          ))}
                      </div>
                      <div className="col-md-12 d-flex align-items-start gap-2">
                        <img
                          src="https://goodhand.b-cdn.net/Assets/cart/privacy.svg"
                          alt=""
                          className="img-fluid"
                        />
                        <p className="font-14 text-black ff-semibold">
                          We protect your details like they're our own.
                        </p>
                      </div>
                      <div className="text-center d-flex justify-content-center col-12 ">
                        <button
                          className={`btn btn-primary w-50 font-14 ff-semibold mt-2 bt--cart ${
                            areAllFieldsUploaded ? "" : "disabled"
                          }`}
                          disabled={!areAllFieldsUploaded}
                          onClick={() => handleContinue()}
                        >
                          {/* <button className="btn btn-primary w-50 font-14 ff-semibold  mt-2  bt--cart disabled"> */}
                          Continue
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          {!isMobile && (
            <div className="upload-right">
              {uploadFieldData &&
                uploadFieldData?.instructions &&
                uploadFieldData?.instructions.length > 0 && (
                  <div
                    className="bg-white rounded-3  p-0 layout-border"
                    style={{ maxWidth: "425px", margin: "0 auto" }}
                  >
                    <div className="d-flex align-items-center mb-3 font-16 ff-bold px-3 py-2 bg-2">
                      <span className="me-2">
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/scan.svg"
                          alt=""
                        />
                      </span>{" "}
                      Upload or Scan {uploadFieldData.shortName}
                    </div>
                    <div className="px-4 pb-4 text-black-50">
                      <img
                        className="d-block mx-auto mb-2"
                        src="https://goodhand.b-cdn.net/Assets/Upload/cloud-upload.svg"
                        alt="Document Illustration"
                        style={{ height: "130px" }}
                      />

                      {uploadFieldData.instructions.map(
                        (instruction: any, index: number) => (
                          <>
                            {instruction.content && (
                              <p className="font-13 ff-medium mb-2">
                                {instruction.content}
                              </p>
                            )}
                            {instruction.title && (
                              <div className="font-15 ff-semibold mb-2 text-black">
                                {instruction.title}
                              </div>
                            )}
                            <ul
                              className={`ps-3 font-13 ff-medium ${
                                instruction.content ? "text-primary" : ""
                              } mb-2`}
                              key={`instruction_${index}`}
                            >
                              {instruction.description
                                .split("----")
                                .map((desc: string, descIndex: number) => (
                                  <li
                                    className="mb-2"
                                    key={`instructionDesc_${descIndex}`}
                                  >
                                    {desc.trim()}
                                  </li>
                                ))}
                            </ul>
                          </>
                        )
                      )}
                    </div>
                  </div>
                )}
              <Certification />
            </div>
          )}
        </div>
        {openModel && session && (
          <CameraModel
            data={`${AppUrl}/mobile-upload/${session.sessionId}`}
            sessionId={session.sessionId}
          />
        )}

        {serviceListDisplayModel && (
          <ServiceListDisplayModel applicantLabel={applicantLabel ?? ""} />
        )}
        {documentsDisplayModel && <DocumentsDisplayModel />}
        {tickModel && <TickModel />}
        <HandlePackageAndServiceModel />
      </section>

      {isMobile && (
        <>
          <Modal
            show={showUploadMobileModal}
            onHide={closeUploadMobileModal}
            scrollable
            className="mb-fix slide-from-bottom"
            backdrop="static"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <div className="applicant-list px-2">
                <Accordion activeKey={activeAccordion}>
                  {responseData &&
                    responseData.map(
                      (item: any, index: number) =>
                        item?.ServiceIncludedDetail.length > 0 && (
                          <Accordion.Item
                            eventKey={`active-${index}`}
                            className={`applicant-box ${getClassForStatus(
                              item,
                              index,
                              activeAccordion
                            )}`}
                          >
                            <Accordion.Header>
                              <div
                                className="d-flex justify-content-between align-items-center p-3 w-100"
                                onClick={() =>
                                  handleAccordionToggle(
                                    `active-${index}`,
                                    item.FormFields
                                  )
                                }
                              >
                                <div className="d-flex align-items-center">
                                  {item.FormFields.every(
                                    (field: { uploaded: boolean }) =>
                                      field.uploaded
                                  ) && (
                                    <div className="tick-sv-icon">
                                      <svg
                                        width="18"
                                        height="19"
                                        viewBox="0 0 18 19"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                          fill="#458E4A"
                                        />
                                      </svg>
                                    </div>
                                  )}
                                  <span
                                    className={`flag-icon flag-icon-${
                                      item.Applicant_Country
                                        ? item.Applicant_Country.toLowerCase()
                                        : "ae"
                                    } me-1`}
                                  ></span>
                                  <p className="mb-0 text-black ff-medium font-14 upload-aaplicant-name">
                                    &nbsp;
                                    {item?.applicant_Name?.length > 22
                                      ? `${item.applicant_Name.slice(0, 22)}...`
                                      : item.applicant_Name}{" "}
                                    - {item.Applicant_PassPort}
                                  </p>
                                  <p className="mb-0 ms-2 d-flex">
                                    <svg
                                      width="14"
                                      height="9"
                                      viewBox="0 0 14 9"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M1 1.5L7 7.5L13 1.5"
                                        stroke="#282828"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>
                                  </p>
                                </div>
                                <div
                                  className="service-badge text-main ff-semibold font-13"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setApplicantLabel(
                                      item.applicant_Name +
                                        " - " +
                                        item.Applicant_PassPort
                                    );
                                    dispatch(
                                      openServiceListDisplayModel(
                                        item?.ServiceIncludedDetail
                                      )
                                    );
                                    closeUploadMobileModal();
                                  }}
                                >
                                  {item.ServiceIncludedDetail &&
                                  item.ServiceIncludedDetail.length > 0
                                    ? item.ServiceIncludedDetail.length
                                    : 0}{" "}
                                  Services
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body className="p-0">
                              <div className="upload-box p-0">
                                <div className="upload-title d-flex align-items-center justify-content-between py-3 px-3 border-bottom mb-0 font-13 text-black ff-medium">
                                  <span>
                                    {" "}
                                    Total {item.FormFields.length} Documents
                                  </span>
                                  {item.FormFields.filter(
                                    (field: any) => field.uploaded
                                  ).length > 0 && (
                                    <div className="p-2 py-1 rounded-pill  bg-light-green text-dark-green ff-semibold font-11">
                                      {
                                        item.FormFields.filter(
                                          (field: any) => field.uploaded
                                        ).length
                                      }{" "}
                                      Uploaded{" "}
                                      <span className="ms-2">
                                        <svg
                                          width="14"
                                          height="14"
                                          viewBox="0 0 14 14"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M10.5001 0.937925C11.5559 1.54752 12.4342 2.42229 13.048 3.47563C13.6619 4.52898 13.9899 5.72436 13.9998 6.94346C14.0096 8.16256 13.7009 9.36309 13.1042 10.4262C12.5075 11.4893 11.6434 12.3782 10.5976 13.0047C9.55179 13.6313 8.36046 13.9739 7.14156 13.9986C5.92265 14.0232 4.71844 13.7291 3.64813 13.1454C2.57782 12.5616 1.67853 11.7085 1.03928 10.6704C0.400028 9.63228 0.042987 8.44522 0.00350012 7.22672L0 6.99992L0.00350012 6.77312C0.0427028 5.56422 0.394488 4.3861 1.02456 3.35362C1.65463 2.32114 2.54149 1.46954 3.59867 0.881842C4.65585 0.294144 5.84727 -0.00959755 7.05679 0.000231172C8.26631 0.0100599 9.45264 0.333123 10.5001 0.937925ZM9.59502 5.10502C9.47448 4.9845 9.31411 4.9121 9.14399 4.9014C8.97387 4.89071 8.80569 4.94245 8.67101 5.04692L8.60521 5.10502L6.30008 7.40942L5.39497 6.50502L5.32917 6.44692C5.19447 6.34252 5.02632 6.29084 4.85624 6.30157C4.68616 6.3123 4.52584 6.38471 4.40534 6.50521C4.28484 6.62571 4.21243 6.78603 4.2017 6.95611C4.19097 7.12618 4.24265 7.29433 4.34705 7.42902L4.40515 7.49482L5.80517 8.89482L5.87097 8.95292C5.99373 9.04817 6.1447 9.09986 6.30008 9.09986C6.45546 9.09986 6.60642 9.04817 6.72918 8.95292L6.79498 8.89482L9.59502 6.09482L9.65312 6.02902C9.7576 5.89434 9.80934 5.72617 9.79864 5.55605C9.78795 5.38593 9.71554 5.22556 9.59502 5.10502Z"
                                            fill="#4E8059"
                                          />
                                        </svg>
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div className="p-2 pt-0 px-3 doc-listing-inside">
                                  {item.FormFields &&
                                  item.FormFields.length > 0 ? (
                                    item.FormFields.map(
                                      (field: Field, fieldIndex: number) => (
                                        <div
                                          className="doc-row"
                                          key={fieldIndex}
                                        >
                                          <div
                                            className={`doc-left d-flex align-items-center gap-2 ${getClassForField(
                                              field
                                            )}`}
                                          >
                                            {/* upcoming, done, completed */}
                                            <div
                                              className={`tick-sv-icon ${getClassForField(
                                                field
                                              )}`}
                                            >
                                              <svg
                                                width="18"
                                                height="19"
                                                viewBox="0 0 18 19"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <path
                                                  d="M13.5 1.7059C14.8574 2.48967 15.9866 3.61437 16.7758 4.96867C17.565 6.32296 17.9868 7.85989 17.9995 9.4273C18.0121 10.9947 17.6152 12.5382 16.848 13.9051C16.0808 15.272 14.9699 16.4148 13.6253 17.2204C12.2807 18.026 10.749 18.4664 9.18188 18.4981C7.61474 18.5299 6.06649 18.1517 4.69039 17.4012C3.3143 16.6507 2.15808 15.5538 1.3362 14.219C0.514315 12.8843 0.0552683 11.3581 0.0045001 9.79149L0 9.49989L0.0045001 9.20829C0.0549028 7.65398 0.507192 6.13926 1.31727 4.81179C2.12736 3.48432 3.26758 2.38941 4.6268 1.6338C5.98601 0.878184 7.51782 0.48766 9.07289 0.500297C10.628 0.512934 12.1532 0.9283 13.5 1.7059ZM12.3363 7.06359C12.1813 6.90863 11.9751 6.81555 11.7564 6.80179C11.5377 6.78804 11.3214 6.85457 11.1483 6.98889L11.0637 7.06359L8.09999 10.0264L6.93629 8.86359L6.85169 8.78889C6.67852 8.65466 6.46233 8.58821 6.24366 8.60201C6.02499 8.6158 5.81886 8.7089 5.66393 8.86383C5.509 9.01876 5.41591 9.22488 5.40211 9.44355C5.38832 9.66222 5.45476 9.87841 5.58899 10.0516L5.66369 10.1362L7.46369 11.9362L7.54829 12.0109C7.70613 12.1333 7.90022 12.1998 8.09999 12.1998C8.29976 12.1998 8.49385 12.1333 8.65169 12.0109L8.73629 11.9362L12.3363 8.33619L12.411 8.25159C12.5453 8.07843 12.6118 7.8622 12.5981 7.64348C12.5843 7.42476 12.4912 7.21857 12.3363 7.06359Z"
                                                  fill="#458E4A"
                                                />
                                              </svg>
                                            </div>
                                            <span
                                              onClick={() => {
                                                fileSelecteChange(field);
                                              }}
                                              className="each-doc-list"
                                            >
                                              {field.Label}
                                            </span>
                                          </div>

                                          {isUploadedField(field) && (
                                            <div className="doc-actions d-flex align-items-center gap-2">
                                              <div
                                                className="d-flex align-items-center justify-content-center upEye"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  dispatch(
                                                    setFromDeleteDoc(false)
                                                  );
                                                  dispatch(
                                                    openDocumentsDisplayModel(
                                                      field
                                                    )
                                                  );
                                                  closeUploadMobileModal();
                                                }}
                                              >
                                                <img
                                                  src="https://goodhand.b-cdn.net/Assets/Upload/up-eye.svg"
                                                  alt=""
                                                />
                                              </div>
                                              <div
                                                className="d-flex align-items-center justify-content-center upDlt"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                  dispatch(
                                                    setFromDeleteDoc(true)
                                                  );
                                                  dispatch(
                                                    openDocumentsDisplayModel(
                                                      field
                                                    )
                                                  );
                                                }}
                                              >
                                                <img
                                                  src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg"
                                                  alt=""
                                                />
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      )
                                    )
                                  ) : (
                                    <div className="no-docs text-center py-3">
                                      No documents to upload
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Body>
                          </Accordion.Item>
                        )
                    )}
                </Accordion>
              </div>
            </Modal.Body>
            <Modal.Footer className="shadow-none border-top">
              <Button
                variant="primary"
                className="w-100 fw-semibold py-3"
                onClick={closeUploadMobileModal}
              >
                OKAY, GOT IT
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={showGuidelineMobileModal}
            onHide={closeGuidelineMobileModal}
            scrollable
            className="mb-fix slide-from-bottom"
            backdrop="static"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body className="shadow-none">
              <div className="border-bottom pb-3 font-14 ff-semibold">
                Follow the below guideline to upload document
              </div>
              <div className="upload-right">
                {uploadFieldData &&
                  uploadFieldData?.instructions &&
                  uploadFieldData?.instructions.length > 0 && (
                    <div
                      className="bg-white rounded-3  p-0 layout-border"
                      style={{ maxWidth: "425px", margin: "0 auto" }}
                    >
                      <div className="d-flex align-items-center mb-3 font-16 ff-bold px-3 py-2 bg-2">
                        <span className="me-2">
                          <img
                            src="https://goodhand.b-cdn.net/Assets/Upload/scan.svg"
                            alt=""
                          />
                        </span>{" "}
                        Upload or Scan {uploadFieldData.shortName}
                      </div>
                      <div className="px-4 pb-4 text-black-50">
                        <img
                          className="d-block mx-auto mb-2"
                          src="https://goodhand.b-cdn.net/Assets/Upload/cloud-upload.svg"
                          alt="Document Illustration"
                          style={{ height: "130px" }}
                        />

                        {uploadFieldData.instructions.map(
                          (instruction: any, index: number) => (
                            <>
                              {instruction.content && (
                                <p className="font-13 ff-medium mb-2">
                                  {instruction.content}
                                </p>
                              )}
                              {instruction.title && (
                                <div className="font-15 ff-semibold mb-2 text-black">
                                  {instruction.title}
                                </div>
                              )}
                              <ul
                                className={`ps-3 font-13 ff-medium ${
                                  instruction.content ? "text-primary" : ""
                                } mb-2`}
                                key={`instruction_${index}`}
                              >
                                {instruction.description
                                  .split("----")
                                  .map((desc: string, descIndex: number) => (
                                    <li
                                      className="mb-2"
                                      key={`instructionDesc_${descIndex}`}
                                    >
                                      {desc.trim()}
                                    </li>
                                  ))}
                              </ul>
                            </>
                          )
                        )}
                      </div>
                    </div>
                  )}
                <Certification />
              </div>
            </Modal.Body>
            <Modal.Footer className="shadow-none border-top">
              <Button
                variant="primary"
                className="w-100 fw-semibold py-3"
                onClick={closeGuidelineMobileModal}
              >
                OKAY, GOT IT
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )}
    </>
  );
};

export default UploadDocumentLatest;
